import { Section } from "@/components/common/section/Section";
import { Offer, OfferProps } from "./offer/Offer";
import {
  Miscellaneous,
  MiscellaneousProps,
} from "./miscellaneous/Miscellaneous";
import styles from "./OfferTypes.module.scss";

export type OfferTypesProps = {
  title: string;
  offers: OfferProps[];
  miscellaneous: MiscellaneousProps;
};

export const OfferTypes = ({
  offers,
  miscellaneous,
  title,
}: OfferTypesProps) => {
  return (
    <Section sectionStyle={styles.section}>
      <Miscellaneous {...miscellaneous} />
      <div className={styles.offerTypes}>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.offer}>
          {offers.map((offer, index) => (
            <Offer {...offer} key={index} isChrono={index === 0} />
          ))}
        </div>
      </div>
    </Section>
  );
};
